/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_TagsInputs */

const en_control_planner_tags = /** @type {(inputs: Control_Planner_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Playstyle tags`)
};

const zh_control_planner_tags = /** @type {(inputs: Control_Planner_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`玩法标签`)
};

/**
* | output |
* | --- |
* | "Playstyle tags" |
*
* @param {Control_Planner_TagsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_tags = /** @type {((inputs?: Control_Planner_TagsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_TagsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_tags(inputs)
	return zh_control_planner_tags(inputs)
});
export { control_planner_tags as "control.planner.tags" }